<template>
  <div id="about" class="">
    <div class="about-jumbotron parallax">
      <h2 class="about-jumbotron-content">
        CHI SIAMO
      </h2>
    </div>

    <div class="container">
    <section class="container my-5">
      <h4 class="mb-4">PUNTO DI CONNESSIONE TRA PERSONE E ARTE</h4>
      <p class="mt-3">
        Galleria Stefano Forni è più di un punto di riferimento per l’arte contemporanea in Italia.
        È un punto di connessione tra artisti, collezionisti, appassionati d’arte, critici, curatori, accademie
        e giovani talenti.
      </p>
      <p class="mt-3">
        È luogo. Uno spazio espositivo, dedicato alla pittura, scultura, grafica e fotografia.
        Rappresentiamo artisti eccellenti tra cui Luciano Ventrone, Armodio, Piero Guccione, Gianfranco
        Ferroni, Carlo Mattioli e molti altri.
      </p>
      <p class="mt-3">
        È dialogo continuo sull’arte, sulle sue espressioni e significati profondi, che prende forma
        attraverso mostre personali e collettive, fiere e iniziative, dal vernissage al finissage.
      </p>
    </section>


         <section class="carousel-slide-wrapper p-3 my-5">
    <SplideCarousel class="container" :options="splideOptions">
      <SplideSlide v-for="(slide, index) in slides" :key="index">

        <div class="row p-3">
          <div class="col-12 mb-3">
            <h4 class="text-center">{{ slide.title }}</h4>
          </div>
          <div class="col-12">
            <div class="carousel-image-container text-center">
              <img :src="slide.image" style="max-height: 300px; max-width: 100%;" :alt="slide.title" />
            </div>
          </div>
          <div class="col-12">
            <div class="carousel-info my-2">
              <p>{{ slide.content }}</p>
            </div>
          </div>
        </div>
      </SplideSlide>

    </SplideCarousel>
        </section> 

<section class="my-5">
  <div class="row align-items-center">
    <!-- Immagine: più piccola, con cornice e descrizione -->
    <div class="col-md-5 text-center mb-4 mb-md-0">
      <img
        src="../assets/Silvia.jpeg"
        class="img-fluid rounded shadow"
        style="max-width: 300px;"
        alt="Silvia Forni"
      />
      <small class="text-muted fst-italic d-block mt-2">
        “Ritratto di Silvia Forni”<br>
        Opera realizzata da Renato Barilli
      </small>
    </div>

    <!-- Testo accanto -->
    <div class="col-md-7 text-center text-md-start">
      <h4 class="mb-4">TI DIAMO IL BENVENUTO</h4>
      <p class="lead">
        Siamo sempre lieti di accogliervi in Galleria e farvi scoprire le nostre esposizioni,
        immergendovi nella bellezza dell’arte moderna e contemporanea.
      </p>
      <p>
        Per qualsiasi informazione o richiesta, potete contare sulla professionalità e passione di Silvia Forni.
      </p>
      <a class="btn btn-outline-dark mt-3" :href="contactLink()">
        Contattaci
      </a>
    </div>
  </div>

</section>
    </div>



  </div>
</template>

<script>
export default {
  name: "AboutView",
  data() {
    return {
      splideOptions: {
        type: "slide",
        perPage: 1,
        focus: "center",
        gap: "1rem",
        pagination: true,
        arrows: true,
       autoplay: true,         // Autoplay attivo
  interval: 5000,         // Durata tra slide in millisecondi (5000 = 5 secondi)
  pauseOnHover: true,     // Pausa quando si passa il mouse sopra
},
      slides: [
        {
          title: '1. LA NOSTRA STORIA',
          image: 'https://art.as.virginia.edu/sites/art.as.virginia.edu/files/styles/wide_hero_1600x400/public/2025-03/arthistory01.jpg?h=dad586f2&itok=PuqafQK3',
          content: `L’ispirazione dura un attimo. Ricerca e riflessione artistica, anni.
Dalla sua nascita a oggi Galleria Stefano Forni ha tracciato, scolpito e catturato il significato e
l’importanza dell’arte nel corso di tre decenni di storia.
Galleria Stefano Forni è stata fondata nel 1996. Oggi è diretta da sua moglie Silvia Forni, nella
culla bolognese che diede i natali a Lucio Dalla, indimenticabile artista e icona del cantautorato
italiano.
Negli anni dal 1996 al 2020, la Galleria Stefano Forni ha consolidato il suo ruolo di punto di
riferimento nel panorama artistico italiano, ospitando una vasta gamma di mostre personali e
collettive di artisti di altissimo livello. La galleria ha promosso nomi storici della pittura e della
scultura, rappresentando una varietà di espressioni artistiche che spaziano dall'iperrealismo alla
pittura astratta e figurativa.
Galleria Stefano Forni ha realizzato mostre di grande rilevanza, proponendo opere che hanno
segnato importanti momenti della scena artistica.`
        },
        {
          title: '2. CLUB DELLA GRAFICA',
          image: 'https://www.industrianova.it/wp-content/uploads/2018/09/blog-Picasso3.jpg',
          content: `Il fascino dell’unicità nel multiplo.
Essenziali, come carta e inchiostro.
Esclusivi, come le firme di un’opera d’arte.
I fogli di grafica hanno marcato con segno chiaro e indelebile l’arte moderna e contemporanea
italiana. Oggetto di studio e ricerca per gli allievi delle accademie italiane, le grafiche hanno
aperto la porta d’accesso al prestigioso mondo dell’arte ad appassionati e collezionisti.
Il Club della Grafica ha tracciato, nero su bianco, la storia della Galleria Stefano Forni.
Una storia che ancora oggi amiamo raccontare. Mostrare. Collezionare.
Le tirature limitate e firmate da ciascun artista testimoniano il fascino senza tempo.
Di chi ricerca l’unicità, nell’infinità del multiplo.`
        }
      ]
    };
  },
  methods: {
    contactLink() {
      return "mailto:arte@galleriastefanoforni.com?subject=&body=";
    },
  },
};
</script>


<style lang="scss" scoped>

.about-jumbotron {
  background-image: url("../assets/galleria-stefano-forni.jpg");
  position: relative;
  height: 300px;
  overflow: hidden;
  background-attachment: fixed; /* Effetto parallax */
  background-position: 60% 20%;
  background-size: cover;
  background-repeat: no-repeat; /* Impedisce la ripetizione dell'immagine */
}
/* Overlay trasparente sopra l'immagine */
.about-jumbotron::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Sfondo nero semi-trasparente */
  z-index: 1; /* Metti l'overlay sopra l'immagine ma sotto il testo */
}


/* Parallax effect */
.parallax {
  background-attachment: fixed;
  background-repeat: no-repeat; /* Assicura che l'immagine non si ripeta */
}
.about-jumbotron-content {
  position: absolute;
  bottom: 0; /* Distanza dal bordo inferiore */
  z-index: 2; /* Assicurati che il testo sia sopra l'overlay */
  color: white;
  font-size: 34px;
  text-align: center;
   /* top: 50%; */
  left: 50%;
  transform: translate(-50%, -50%); /* Centra perfettamente il testo */
}
.carousel-slide-wrapper {

  margin: auto;
  border: 0px solid #ccc;         /* Bordo sottile */
  border-radius: 16px;            /* Angoli arrotondati più morbidi */
  background-color: #fff;         /* Sfondo bianco per contrasto pulito */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);  /* Ombra leggera */
}
.carousel-image-container img {
  height: 200px;
  width: 100%;
  object-fit: cover;
}

</style>